(() => {
  const root = document.querySelector('[data-rb-content-manager]');
  if (!root) return;
  const $ = (selector, scope = root) => scope.querySelector(selector);
  const login = $('[data-rb-manager-login]');
  const dashboard = $('[data-rb-manager-dashboard]');
  const signout = $('[data-rb-manager-signout]');
  const list = $('[data-rb-manager-review-list]');
  const editor = $('[data-rb-manager-editor]');
  const form = $('[data-rb-manager-review-form]');
  const notice = $('[data-rb-manager-notice]');
  const formNote = $('[data-rb-manager-form-note]');
  const loginForm = $('[data-rb-manager-login-form]');
  const loginNote = $('[data-rb-manager-login-note]');
  const codeStep = $('[data-rb-manager-code-step]');
  const sendEmailButton = $('[data-rb-manager-send-email]');
  const sendEmailLabel = sendEmailButton.textContent;
  const photoEditor = $('[data-rb-manager-photo-editor]');
  const selectedFiles = $('[data-rb-manager-selected-files]');
  const summaryForm = $('[data-rb-manager-summary-form]');
  const summaryList = $('[data-rb-manager-summary-list]');
  const summaryPreview = $('[data-rb-manager-summary-preview]');
  const summaryNote = $('[data-rb-manager-summary-note]');
  const productNames = { 'pure-goji-30':'纯枸杞 30 天','pure-goji-7':'纯枸杞 7 天','goji-berries-1lb':'有机枸杞 1 磅','goji-berries-2lb':'有机枸杞 2 磅' };
  const maxReviewPhotos = 5;
  let reviews = [];
  let reviewSummaries = [];
  let editorPhotoUrls = [];
  let sendCooldownUntil = 0;
  let sendCooldownTimer = 0;
  const api = () => window.RubystData.client();
  const message = (text) => { notice.textContent = text || ''; };
  const normalizePhotoUrls = (...values) => {
    if (window.RubystData?.normalizeReviewPhotoUrls) return window.RubystData.normalizeReviewPhotoUrls(...values);
    const urls = [];
    const append = (value) => {
      if (Array.isArray(value)) return value.forEach(append);
      const url = String(value || '').trim();
      if (url && !urls.includes(url)) urls.push(url);
    };
    values.forEach(append);
    return urls.slice(0, maxReviewPhotos);
  };
  const reviewPhotoUrls = (review) => normalizePhotoUrls(review?.photo_urls, review?.photo_url);
  const padDatePart = (value) => String(value).padStart(2, '0');
  const toDateTimeLocal = (value = Date.now()) => {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    return `${date.getFullYear()}-${padDatePart(date.getMonth() + 1)}-${padDatePart(date.getDate())}T${padDatePart(date.getHours())}:${padDatePart(date.getMinutes())}`;
  };
  const toIsoDateTime = (value) => {
    const date = new Date(String(value || ''));
    if (Number.isNaN(date.getTime())) throw new Error('请选择有效的评论时间。');
    return date.toISOString();
  };
  const formatManagerDate = (value) => {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '时间未设置';
    return new Intl.DateTimeFormat('zh-CN', {
      year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false,
    }).format(date);
  };
  const renderEditorPhotos = () => {
    photoEditor.replaceChildren(...editorPhotoUrls.map((url, index) => {
      const figure = document.createElement('figure');
      const image = document.createElement('img');
      const remove = document.createElement('button');
      image.src = url;
      image.alt = `评论图片 ${index + 1}`;
      image.loading = 'lazy';
      remove.type = 'button';
      remove.textContent = '×';
      remove.dataset.removeReviewPhoto = String(index);
      remove.setAttribute('aria-label', `移除第 ${index + 1} 张图片`);
      figure.append(image, remove);
      return figure;
    }));
    photoEditor.hidden = editorPhotoUrls.length === 0;
  };
  const updateSelectedFiles = () => {
    const count = form.elements.photo_file.files?.length || 0;
    selectedFiles.textContent = count ? `已选择 ${count} 张；保存后与保留图片合计不能超过 ${maxReviewPhotos} 张` : '';
  };

  const authWaitSeconds = (error) => {
    const match = String(error?.message || '').match(/after\s+(\d+)\s+seconds?/i);
    return match ? Math.max(1, Number(match[1]) || 0) : 0;
  };
  const friendlyAuthError = (error) => {
    const raw = String(error?.message || '').trim();
    const wait = authWaitSeconds(error);
    if (wait) return `请求太频繁，请等待 ${wait} 秒后再试。重复点击不会加快邮件送达。`;
    if (/email address not authorized/i.test(raw)) return '当前 Supabase 默认邮件通道未授权向此邮箱发信。请先连接自定义 SMTP。';
    if (/email rate limit|rate limit exceeded|too many requests/i.test(raw)) return 'Supabase 默认邮件额度或请求次数已达上限。请稍后再试，正式使用需要连接自定义 SMTP。';
    if (/invalid login credentials/i.test(raw)) return '邮箱或密码不正确。';
    if (/token.*expired|otp.*expired|invalid.*token/i.test(raw)) return '验证码无效或已经过期，请重新获取。';
    return raw || '登录邮件发送失败。';
  };
  const updateSendCooldown = () => {
    const remaining = Math.max(0, Math.ceil((sendCooldownUntil - Date.now()) / 1000));
    if (remaining > 0) {
      sendEmailButton.disabled = true;
      sendEmailButton.textContent = `${remaining} 秒后可重新发送`;
      return;
    }
    window.clearInterval(sendCooldownTimer);
    sendCooldownTimer = 0;
    sendEmailButton.disabled = false;
    sendEmailButton.textContent = sendEmailLabel;
  };
  const startSendCooldown = (seconds = 60) => {
    sendCooldownUntil = Date.now() + Math.max(1, seconds) * 1000;
    window.clearInterval(sendCooldownTimer);
    updateSendCooldown();
    sendCooldownTimer = window.setInterval(updateSendCooldown, 250);
  };

  const verifyAdmin = async (session) => {
    if (!session?.user) return false;
    const { data, error } = await api().from('rubyst_admins').select('user_id').eq('user_id', session.user.id).maybeSingle();
    return !error && Boolean(data);
  };
  const setSignedIn = (signedIn) => {
    login.hidden = signedIn;
    dashboard.hidden = !signedIn;
    signout.hidden = !signedIn;
  };
  const summaryForProduct = (productId) => {
    const saved = reviewSummaries.find((item) => item.product_id === productId);
    const savedRating = Number(saved?.rating);
    const savedReviewCount = Number(saved?.review_count);
    return {
      product_id: productId,
      rating: Number.isFinite(savedRating) ? Math.max(1, Math.min(5, savedRating)) : 4.8,
      review_count: Number.isFinite(savedReviewCount) ? Math.max(0, Math.round(savedReviewCount)) : 327,
    };
  };
  const renderSummaryPreview = () => {
    const rating = Math.max(1, Math.min(5, Number(summaryForm.elements.rating.value) || 4.8));
    const count = Math.max(0, Math.round(Number(summaryForm.elements.review_count.value) || 0));
    summaryPreview.querySelector('strong').textContent = rating.toFixed(1);
    summaryPreview.querySelector('em').textContent = `${count} Reviews`;
  };
  const syncSummaryEditor = (productId = summaryForm.elements.product_id.value) => {
    const summary = summaryForProduct(productId);
    summaryForm.elements.product_id.value = productId;
    summaryForm.elements.rating.value = summary.rating.toFixed(1);
    summaryForm.elements.review_count.value = String(summary.review_count);
    renderSummaryPreview();
    summaryList.querySelectorAll('[data-summary-product]').forEach((button) => {
      button.classList.toggle('is-selected', button.dataset.summaryProduct === productId);
    });
  };
  const renderSummaryCards = () => {
    const selectedProduct = summaryForm.elements.product_id.value;
    summaryList.replaceChildren(...Object.entries(productNames).map(([productId, name]) => {
      const summary = summaryForProduct(productId);
      const button = document.createElement('button');
      const label = document.createElement('span');
      const value = document.createElement('strong');
      button.type = 'button';
      button.className = 'rb-content-manager__summary-card';
      button.dataset.summaryProduct = productId;
      button.classList.toggle('is-selected', productId === selectedProduct);
      label.textContent = name;
      value.textContent = `★★★★★ ${summary.rating.toFixed(1)} · ${summary.review_count}`;
      button.append(label, value);
      return button;
    }));
  };
  const visibleReviews = () => {
    const product = $('[data-rb-manager-product-filter]').value;
    const status = $('[data-rb-manager-status-filter]').value;
    return reviews.filter((review) => (!product || review.product_id === product) && (!status || review.status === status));
  };
  const render = () => {
    const visible = visibleReviews();
    list.replaceChildren(...visible.map((review) => {
      const card = document.createElement('article');
      card.className = 'rb-content-manager__review';
      const copy = document.createElement('div');
      const meta = document.createElement('small');
      const body = document.createElement('p');
      const status = document.createElement('span');
      status.className = `rb-content-manager__status${review.status === 'approved' ? '' : ' is-hidden'}`;
      status.textContent = review.status === 'approved' ? '已显示' : review.status === 'pending' ? '待审核' : '已隐藏';
      meta.textContent = `${productNames[review.product_id] || review.product_id} · ${review.customer_name} · ${review.rating} 星 · ${formatManagerDate(review.created_at)}`;
      body.textContent = review.body;
      copy.append(status, meta, body);
      const photos = reviewPhotoUrls(review);
      if (photos.length) {
        const gallery = document.createElement('div');
        gallery.className = 'rb-content-manager__review-photos';
        photos.forEach((url, index) => {
          const image = document.createElement('img');
          image.src = url;
          image.alt = `评论图片 ${index + 1}`;
          image.loading = 'lazy';
          gallery.append(image);
        });
        copy.append(gallery);
      }
      const actions = document.createElement('div');
      actions.className = 'rb-content-manager__review-actions';
      [['编辑','edit'],[review.status === 'approved' ? '隐藏' : '显示',review.status === 'approved' ? 'hide' : 'show'],['删除','delete']].forEach(([label, action]) => {
        const button = document.createElement('button'); button.type = 'button'; button.textContent = label; button.dataset.action = action; button.dataset.id = review.id; if (action === 'delete') button.className = 'is-danger'; actions.append(button);
      });
      card.append(copy, actions);
      return card;
    }));
    $('[data-rb-manager-empty]').hidden = visible.length > 0;
    $('[data-rb-manager-review-count]').textContent = String(reviews.length);
  };
  const load = async () => {
    message('正在读取评论和综合评分…');
    const [reviewResult, summaryResult] = await Promise.all([
      api().from('rubyst_reviews').select('*').order('created_at', { ascending: false }).limit(500),
      api().from('rubyst_review_summaries').select('*').order('product_id', { ascending: true }),
    ]);
    if (reviewResult.error) throw reviewResult.error;
    if (summaryResult.error) throw summaryResult.error;
    reviews = reviewResult.data || [];
    reviewSummaries = summaryResult.data || [];
    render();
    renderSummaryCards();
    syncSummaryEditor();
    message('');
  };
  const resetEditor = () => {
    form.reset(); form.elements.review_id.value = ''; form.elements.created_at.value = toDateTimeLocal(); editor.querySelector('summary').textContent = '＋ 新增评论'; formNote.textContent = ''; editorPhotoUrls = []; renderEditorPhotos(); updateSelectedFiles();
  };

  const finishLogin = async (session) => {
    if (!(await verifyAdmin(session))) {
      await api().auth.signOut();
      throw new Error('此邮箱不是 RUBYST 管理员账号。');
    }
    loginNote.textContent = '';
    setSignedIn(true);
    await load();
  };
  sendEmailButton.addEventListener('click', async (event) => {
    const email = String(loginForm.elements.email.value || '').trim();
    const button = event.currentTarget;
    if (Date.now() < sendCooldownUntil) return;
    if (!email) { loginNote.textContent = '请先填写管理员邮箱。'; return; }
    button.disabled = true;
    loginNote.textContent = '正在发送安全登录邮件…';
    try {
      const { error } = await api().auth.signInWithOtp({ email, options: { shouldCreateUser: false, emailRedirectTo: `${location.origin}${location.pathname}` } });
      if (error) throw error;
      codeStep.hidden = false;
      loginNote.textContent = '登录请求已提交。请在两分钟内查看收件箱和垃圾邮件；如果仍未收到，请不要重复点击，需要先检查 Supabase 自定义 SMTP。';
      startSendCooldown(60);
      loginForm.elements.otp.focus();
    } catch (error) {
      loginNote.textContent = friendlyAuthError(error);
      const wait = authWaitSeconds(error);
      if (wait) startSendCooldown(wait);
    } finally {
      if (Date.now() >= sendCooldownUntil) {
        button.disabled = false;
        button.textContent = sendEmailLabel;
      }
    }
  });
  loginForm.addEventListener('submit', async (event) => {
    event.preventDefault();
    const email = String(loginForm.elements.email.value || '').trim();
    const token = String(loginForm.elements.otp.value || '').replace(/\s+/g, '');
    const submit = event.submitter || loginForm.querySelector('button[type="submit"]');
    if (!email || !token) { loginNote.textContent = '请输入邮件中的验证码。'; return; }
    submit.disabled = true;
    loginNote.textContent = '正在验证…';
    try {
      const { data: auth, error } = await api().auth.verifyOtp({ email, token, type: 'email' });
      if (error) throw error;
      await finishLogin(auth.session);
    } catch (error) { loginNote.textContent = friendlyAuthError(error); }
    finally { submit.disabled = false; }
  });
  $('[data-rb-manager-password-login]').addEventListener('click', async (event) => {
    const email = String(loginForm.elements.email.value || '').trim();
    const password = String(loginForm.elements.password.value || '');
    const button = event.currentTarget;
    if (!email || !password) { loginNote.textContent = '请输入邮箱和现有密码。'; return; }
    button.disabled = true;
    loginNote.textContent = '正在登录…';
    try {
      const { data: auth, error } = await api().auth.signInWithPassword({ email, password });
      if (error) throw error;
      await finishLogin(auth.session);
    } catch (error) { loginNote.textContent = friendlyAuthError(error); }
    finally { button.disabled = false; }
  });
  signout.addEventListener('click', async () => { await api().auth.signOut(); setSignedIn(false); });
  $('[data-rb-manager-refresh]').addEventListener('click', () => load().catch((error) => message(error.message)));
  $('[data-rb-manager-product-filter]').addEventListener('change', render);
  $('[data-rb-manager-status-filter]').addEventListener('change', render);
  summaryList.addEventListener('click', (event) => {
    const button = event.target.closest('[data-summary-product]');
    if (!button) return;
    summaryNote.textContent = '';
    syncSummaryEditor(button.dataset.summaryProduct);
  });
  summaryForm.elements.product_id.addEventListener('change', () => {
    summaryNote.textContent = '';
    syncSummaryEditor(summaryForm.elements.product_id.value);
  });
  summaryForm.addEventListener('input', renderSummaryPreview);
  summaryForm.addEventListener('submit', async (event) => {
    event.preventDefault();
    const productId = String(summaryForm.elements.product_id.value || '');
    const rating = Number(summaryForm.elements.rating.value);
    const reviewCount = Number(summaryForm.elements.review_count.value);
    const submit = summaryForm.querySelector('button[type="submit"]');
    if (!productNames[productId] || !Number.isFinite(rating) || rating < 1 || rating > 5 || !Number.isInteger(reviewCount) || reviewCount < 0) {
      summaryNote.textContent = '请填写 1.0–5.0 的评分和不小于 0 的整数评价数。';
      return;
    }
    submit.disabled = true;
    summaryNote.textContent = '正在保存…';
    try {
      const payload = { product_id: productId, rating: Number(rating.toFixed(1)), review_count: reviewCount, updated_at: new Date().toISOString() };
      const { error } = await api().from('rubyst_review_summaries').upsert(payload, { onConflict: 'product_id' });
      if (error) throw error;
      reviewSummaries = reviewSummaries.filter((item) => item.product_id !== productId).concat(payload);
      renderSummaryCards();
      syncSummaryEditor(productId);
      summaryNote.textContent = `${productNames[productId]} 已保存，刷新产品页即可看到。`;
    } catch (error) {
      summaryNote.textContent = error.message || '综合评分保存失败。';
    } finally {
      submit.disabled = false;
    }
  });
  $('[data-rb-manager-editor-cancel]').addEventListener('click', () => { resetEditor(); editor.open = false; });
  form.elements.photo_file.addEventListener('change', updateSelectedFiles);
  photoEditor.addEventListener('click', (event) => {
    const button = event.target.closest('[data-remove-review-photo]');
    if (!button) return;
    editorPhotoUrls.splice(Number(button.dataset.removeReviewPhoto), 1);
    renderEditorPhotos();
  });
  list.addEventListener('click', async (event) => {
    const button = event.target.closest('button[data-action]'); if (!button) return; const review = reviews.find((item) => item.id === button.dataset.id); if (!review) return;
    if (button.dataset.action === 'edit') {
      resetEditor();
      Object.entries(review).forEach(([key, value]) => {
        if (form.elements[key] && !['created_at', 'photo_file', 'photo_url', 'photo_urls'].includes(key)) form.elements[key].value = value ?? '';
      });
      form.elements.created_at.value = toDateTimeLocal(review.created_at);
      editorPhotoUrls = reviewPhotoUrls(review);
      renderEditorPhotos();
      form.elements.review_id.value = review.id;
      editor.querySelector('summary').textContent = '修改评论';
      editor.open = true;
      form.scrollIntoView({ behavior:'smooth',block:'center' });
      return;
    }
    if (button.dataset.action === 'delete' && !window.confirm('确定永久删除这条评论吗？')) return;
    button.disabled = true;
    try { const query = api().from('rubyst_reviews'); const { error } = button.dataset.action === 'delete' ? await query.delete().eq('id',review.id) : await query.update({ status:button.dataset.action === 'show' ? 'approved' : 'rejected' }).eq('id',review.id); if (error) throw error; await load(); message(button.dataset.action === 'delete' ? '评论已删除' : '评论状态已更新'); }
    catch (error) { message(error.message || '操作失败'); }
    finally { button.disabled = false; }
  });
  form.addEventListener('submit', async (event) => {
    event.preventDefault(); const data = new FormData(form); const id = String(data.get('review_id') || ''); const submit = form.querySelector('button[type="submit"]'); submit.disabled = true; formNote.textContent = '正在保存…';
    try {
      const existing = reviews.find((review) => review.id === id);
      const files = Array.from(form.elements.photo_file.files || []);
      if (editorPhotoUrls.length + files.length > maxReviewPhotos) throw new Error(`一条评论最多只能有 ${maxReviewPhotos} 张图片。`);
      const uploaded = await window.RubystData.uploadReviewPhotos(files);
      const photoUrls = normalizePhotoUrls(editorPhotoUrls, uploaded);
      const createdAt = toIsoDateTime(data.get('created_at'));
      const payload = {
        product_id: String(data.get('product_id')),
        customer_name: String(data.get('customer_name')).trim(),
        rating: Number(data.get('rating')),
        status: String(data.get('status')),
        title: createdAt.slice(0, 10),
        body: String(data.get('body')).trim(),
        photo_url: photoUrls[0] || null,
        photo_urls: photoUrls,
        source: existing?.source || 'Manual',
        created_at: createdAt,
      };
      const { error } = id ? await api().from('rubyst_reviews').update(payload).eq('id',id) : await api().from('rubyst_reviews').insert(payload);
      if (error) throw error;
      await load();
      resetEditor();
      editor.open = false;
      message(id ? '评论已修改' : '评论已新增');
    }
    catch (error) { formNote.textContent = error.message || '保存失败'; }
    finally { submit.disabled = false; }
  });

  resetEditor();
  (async () => { try { const { data:{ session } } = await api().auth.getSession(); const valid = session && await verifyAdmin(session); setSignedIn(Boolean(valid)); if (valid) await load(); else if (session) await api().auth.signOut(); } catch (error) { setSignedIn(false); loginNote.textContent = error.message || '后台连接失败'; } })();
})();
